<template>
    <v-app id="main" :dark="dark" :light="!dark">
        <v-content>
            <v-container fluid grid-list-xl class="py-5 image-bg2 image-bg">
                <vorsi-toolbar></vorsi-toolbar>
                <v-layout column class="text-xs-center">
                    <div>
                        <div class="display-1 pt-5">
                            <b>How Can We Help?</b>
                        </div>
                        <div class="headline pt-2 pb-5">
                            Call or email us to ask about our software.
                        </div>
                    </div>
                </v-layout>
                <v-layout row wrap class="text-xs-center" justify-center>
                    <v-flex xs12 md6 lg3 class="headline py-5">
                        <a href='tel:+19178469154' style="text-decoration: none; cursor: pointer; color: white">
                            <v-btn large icon color="mb-3">
                                <v-icon style="font-size: 50px;">
                                    mdi-phone
                                </v-icon>
                            </v-btn>
                        </a>
                        <br>
                        <a href='tel:+19178469154' style="text-decoration: none; cursor: pointer; color: white">
                            <b>917 846 9154</b>
                        </a>
                    </v-flex>
                    <!--                    <v-flex xs12 md6 lg3 class="headline py-5">-->
                    <!--                        <v-btn large icon @click="goTo('https://discord.gg/XHMz2K2')" color="mb-3">-->
                    <!--                            <v-icon style="font-size: 50px;">-->
                    <!--                                mdi-discord-->
                    <!--                            </v-icon>-->
                    <!--                        </v-btn>-->
                    <!--                        <br>-->
                    <!--                        <a href='https://discord.gg/XHMz2K2'-->
                    <!--                           style="text-decoration: none; cursor: pointer; color: white">-->
                    <!--                            <b>Discord Channel</b>-->
                    <!--                        </a>-->
                    <!--                    </v-flex>-->
                    <v-flex xs12 md6 lg3 class="headline py-5">
                        <a href='mailto:support@vorsi.io' style="text-decoration: none; cursor: pointer; color: white">
                            <v-btn large icon color="mb-3">
                                <v-icon style="font-size: 50px;">
                                    mdi-email
                                </v-icon>
                            </v-btn>
                        </a>
                        <br>
                        <a href='mailto:support@vorsi.io' style="text-decoration: none; cursor: pointer; color: white">
                            <b>support@vorsi.io</b>
                        </a>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-container fluid grid-list-xl class="py-5" style="max-width: 1200px;">
                <v-layout row wrap justify-center v-if="disabled" style="text-align: center;"
                          class="headline">
                    <v-flex xs12><b>Thank You For Contacting Us! We will respond soon.</b></v-flex>
                </v-layout>
                <v-layout row wrap justify-center v-if="!disabled">
                    <v-flex xs12 md6>
                        <v-text-field
                            label="First Name"
                            v-model="FirstName"
                            outline
                            color="secondary"
                            :error-messages="FirstNameErrors"
                            @input="delayTouch($v.FirstName)"
                            @blur="$v.FirstName.$touch()"
                            :disabled="disabled"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-text-field
                            label="Last Name"
                            v-model="LastName"
                            outline
                            color="secondary"
                            :error-messages="LastNameErrors"
                            @input="delayTouch($v.LastName)"
                            @blur="$v.LastName.$touch()"
                            :disabled="disabled"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-text-field
                            label="Email"
                            v-model="Email"
                            outline
                            color="secondary"
                            :error-messages="EmailErrors"
                            @input="delayTouch($v.Email)"
                            @blur="$v.Email.$touch()"
                            :disabled="disabled"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-text-field
                            label="Phone"
                            v-model="Phone"
                            outline
                            color="secondary"
                            :error-messages="PhoneErrors"
                            @input="delayTouch($v.Phone)"
                            @blur="$v.Phone.$touch()"
                            :disabled="disabled"
                            mask="(###) ### - ####"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-text-field
                            label="Company"
                            v-model="Company"
                            outline
                            color="secondary"
                            :error-messages="CompanyErrors"
                            @input="delayTouch($v.Company)"
                            @blur="$v.Company.$touch()"
                            :disabled="disabled"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-text-field
                            label="Position"
                            v-model="Position"
                            outline
                            color="secondary"
                            :error-messages="PositionErrors"
                            @input="delayTouch($v.Position)"
                            @blur="$v.Position.$touch()"
                            :disabled="disabled"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-checkbox
                            label="Interested in a demo"
                            v-model="Demo"
                            color="secondary"
                            :disabled="disabled"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-text-field
                            label="Number Of Office Employees"
                            v-model="CompanySize"
                            outline
                            color="secondary"
                            :error-messages="CompanySizeErrors"
                            @input="delayTouch($v.CompanySize)"
                            @blur="$v.CompanySize.$touch()"
                            :disabled="disabled"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 style="border: #ababab solid 2px; border-radius: 3px; margin: 0 12px 0 12px">
                        <v-layout row wrap>
                            <v-flex xs1 class="text-xs-center py-3"
                                    style="background-color: #5e35b1; border-radius: 3px">
                                <v-icon>
                                    mdi-information
                                </v-icon>
                            </v-flex>
                            <v-flex xs11 class="subheading py-3 pl-3">
                                <b>Note:</b> For technical queries, please contact us at 917 846 9154.
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12>
                        <v-textarea
                            label="How Can We Help?"
                            v-model="Help"
                            outline
                            color="secondary"
                            :error-messages="HelpErrors"
                            @input="delayTouch($v.Help)"
                            @blur="$v.Help.$touch()"
                            :disabled="disabled"
                        ></v-textarea>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                        We Respond Within 24 Hours
                    </v-flex>
                    <v-flex xs12>
                        <v-layout row wrap justify-center>
                            <v-btn
                                color="secondary"
                                @click="submit()"
                                :loading="loading"
                                :disabled="isDisabled()"
                            >submit
                            </v-btn>
                        </v-layout>
                    </v-flex>
                    <div style="position: fixed; width: 100%; top:15%">
                        <div style="width: 80%; margin: 0 auto">
                            <v-alert v-model="showAlert" :type="alertType">{{ alertMessage }}</v-alert>
                        </div>
                    </div>
                </v-layout>
            </v-container>
        </v-content>
        <vorsi-footer></vorsi-footer>
    </v-app>
</template>

<script>
import {required, email, helpers} from 'vuelidate/lib/validators';

const touchMap = new WeakMap();
const regex = new RegExp(/^[+]?(([0-9]{1})[-\s.]?)?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4}$/);
const phoneCheck = (value) => !helpers.req(value) || regex.test(value);

export default {
    data: () => ({
        loading: false,
        disabled: false,
        showAlert: false,
        alertType: 'success',
        alertMessage: '',
        dark: true,
        FirstName: null,
        LastName: null,
        Email: null,
        Phone: null,
        Company: null,
        Position: null,
        Demo: false,
        CompanySize: null,
        Help: null,
        token: null,
    }),
    validations: {
        FirstName: {required},
        LastName: {required},
        Email: {required, email},
        Phone: {required, phoneCheck},
        Company: {required},
        Position: {required},
        CompanySize: {required},
        Help: {required},
    },
    mounted() {
        window.addEventListener('load', () => {
            let intervalID = setInterval(() => {
                if (typeof grecaptcha !== undefined) {
                    this.getReCaptchaToken();
                    clearInterval(intervalID);
                }
            }, 100);
        });
    },
    destroyed() {
        window.removeEventListener('load', () => {
            let intervalID = setInterval(() => {
                if (typeof grecaptcha !== undefined) {
                    this.getReCaptchaToken();
                    clearInterval(intervalID);
                }
            }, 100);
        });
    },
    methods: {
        submit() {
            this.$v.$touch();
            if (!this.$v.$anyError && !this.loading) {
                this.loading = true;
                this.disabled = true;
                axios.post('/contact-us',
                    {
                        FirstName: this.FirstName,
                        LastName: this.LastName,
                        Email: this.Email,
                        Phone: this.Phone,
                        Company: this.Company,
                        Position: this.Position,
                        Demo: this.Demo,
                        CompanySize: this.CompanySize,
                        Help: this.Help,
                        token: this.token,
                    }).then(response => {
                    this.clear();
                }).catch(error => {
                    this.showAlert = true;
                    this.alertType = 'error';
                    this.alertMessage = 'An error occurred processing your request.';
                    this.disabled = false;
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        delayTouch($v) {
            $v.$reset();
            if (touchMap.has($v)) clearTimeout(touchMap.get($v));
            touchMap.set($v, setTimeout($v.$touch, 100));
        },
        clear() {
            this.Email = null;
            this.FirstName = null;
            this.LastName = null;
            this.Phone = null;
            this.Company = null;
            this.Position = null;
            this.Demo = false;
            this.CompanySize = null;
            this.Help = null;
            setTimeout(() => {
                this.$v.$reset();
            }, 250);
        },
        getReCaptchaToken() {
            grecaptcha.ready(() => {
                grecaptcha.execute(process.env.MIX_reCAPTCHA_KEY, {action: 'contact_us'})
                    .then((token) => {
                        this.token = token;
                    });
            });
        },
        isDisabled() {
            return (!this.$v.$anyDirty || this.$v.$anyError || this.disabled)
        },
        goTo(route) {
            window.location = route;
        },
    },
    computed: {
        FirstNameErrors() {
            const errors = [];
            if (!this.$v.FirstName.$dirty) return errors;
            !this.$v.FirstName.required && errors.push('First Name is required.');
            return errors;
        },
        LastNameErrors() {
            const errors = [];
            if (!this.$v.LastName.$dirty) return errors;
            !this.$v.LastName.required && errors.push('Last Name is required.');
            return errors;
        },
        EmailErrors() {
            const errors = [];
            if (!this.$v.Email.$dirty) return errors;
            !this.$v.Email.required && errors.push('Email is required.');
            !this.$v.Email.email && errors.push('Not a valid email.');
            return errors;
        },
        PhoneErrors() {
            const errors = [];
            if (!this.$v.Phone.$dirty) return errors;
            !this.$v.Phone.required && errors.push('Phone is required.');
            !this.$v.Phone.phoneCheck && errors.push('Not a valid phone number.');
            return errors;
        },
        CompanyErrors() {
            const errors = [];
            if (!this.$v.Company.$dirty) return errors;
            !this.$v.Company.required && errors.push('Company is required.');
            return errors;
        },
        PositionErrors() {
            const errors = [];
            if (!this.$v.Position.$dirty) return errors;
            !this.$v.Position.required && errors.push('Position is required.');
            return errors;
        },
        CompanySizeErrors() {
            const errors = [];
            if (!this.$v.CompanySize.$dirty) return errors;
            !this.$v.CompanySize.required && errors.push('Number of Office Employees is required.');
            return errors;
        },
        HelpErrors() {
            const errors = [];
            if (!this.$v.Help.$dirty) return errors;
            !this.$v.Help.required && errors.push('Help is required.');
            return errors;
        },
    },
};
</script>

<style scoped>

</style>
